require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-elliot-chong.json") })
        }
      }, "path---blog-author-elliot-chong");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-elliot-chong!./.cache/json/blog-author-elliot-chong.json
// module id = 639
// module chunks = 231608221292675